import { createFileRoute } from '@tanstack/react-router';
import { AskTrainerSection } from '@/features/Lesson/AskTrainerSection';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/ask-trainer')({
  component: AskTrainerRoute,
});

function AskTrainerRoute() {
  const { topicId } = Route.useParams();
  return <AskTrainerSection topicId={topicId} />;
}
